import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';

const CONNECTION_ERROR_ROUTE = '/cotizador/error/conexion';

export const internetConnectionGuard: CanActivateChildFn = (_route, state) => {
  if (typeof navigator === 'undefined' || navigator.onLine) {
    return true;
  }

  if (state.url.startsWith(CONNECTION_ERROR_ROUTE)) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree([CONNECTION_ERROR_ROUTE]);
};
